import { ComponentVideoType } from "@swo/storefront";
import { useCallback, useState } from "react";

export type VideoComponentCaptionsT = "not-available" | "visible" | "hidden";

export function useCaptionsState(videoSubtitles: ComponentVideoType["video"]["subtitles"]) {
  const [captionsState, setCaptionsState] = useState<VideoComponentCaptionsT>(
    videoSubtitles ? "hidden" : "not-available",
  );

  const toggleCaptionsState = useCallback(() => {
    setCaptionsState(s => {
      if (s === "hidden") {
        return "visible";
      } else if (s === "visible") {
        return "hidden";
      } else {
        return "not-available";
      }
    });
  }, [videoSubtitles]);

  return [captionsState, toggleCaptionsState] as const;
}
